(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["online-store-closure-modal"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-online-store-closure-modal]').forEach(function (dialog) {
    if (dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';

    var cookieName = dialog.dataset.cookieName;
    var startsAt = Date.parse(dialog.dataset.startsAt);
    var endsAt = Date.parse(dialog.dataset.endsAt);
    var closeButtons = dialog.querySelectorAll('[data-closure-modal-close]');
    var dismissButton = dialog.querySelector('[data-closure-modal-dismiss]');
    var detailsLink = dialog.querySelector('[data-closure-modal-details]');

    function hasDismissalCookie() {
      var encodedName = encodeURIComponent(cookieName) + '=';
      return document.cookie.split('; ').some(function (entry) {
        return entry.indexOf(encodedName) === 0;
      });
    }

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    function dismissDialog() {
      var maxAge = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
      document.cookie = encodeURIComponent(cookieName) + '=1; Path=/; Max-Age=' + maxAge + '; SameSite=Lax; Secure';
      closeDialog();
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDialog);
    });

    if (dismissButton) dismissButton.addEventListener('click', dismissDialog);
    if (detailsLink) detailsLink.addEventListener('click', closeDialog);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });

    var now = Date.now();
    if (Number.isNaN(startsAt) || Number.isNaN(endsAt)) return;
    if (now < startsAt || now >= endsAt || hasDismissalCookie()) return;
    dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

})();
